<!-- tab 页中的 商家相册-->
<template>
<div class="album">
    <div class="filter">
        <div class="item" :class="{'active':atlasParams.tagIdList.length == 0}" @click="filterChange(0)">全部</div>
        <div class="item" v-for="item in tagsList" :key="item.id" :class="{'active':atlasParams.tagIdList.includes(item.id)}" @click="filterChange(item.id)">{{ item.name }}</div>
        <div class="sort">
            <div class="lit" :class="{active:atlasParams.order == 0}" @click="orderChange(0)">默认排序</div>
            <div class="lit" :class="{active:atlasParams.order == 1}"  @click="orderChange(1)">时间排序</div>
        </div>
    </div>
    <ul class="atlas-list" v-loading="postLoading">
        <li v-for="item in atlasList" :key="item.id" @click="showPrev(item)">
            <div class="box">
                <img :src="item.url|webpFormat(350)" alt="">
                <div class="dish-box" v-if="item.dish.id">
                    <div class="dish-name">{{ item.dish.name }}</div>
                    <div class="dish-price" v-if="item.dish.price>0">${{ item.dish.price }}</div>
                </div>
            </div>
        </li>
    </ul>
    <div class="paging" style="text-align:center">
        <el-pagination
            background
            @current-change="pageChange"
            layout="prev, pager, next"
            :page-size="atlasParams.size"
            :hide-on-single-page="true"
            :total="atlasCount">
        </el-pagination>
    </div>
    <div class="no-data" v-if="!postLoading && atlasList.length==0">
        <img :src="require('@/assets/images/common/no-data.png')" alt="">
        <div class="note">暂没有数据</div>
    </div>
    <el-image style="width:0; height:0" ref="elImgPrev" :src="controlData.url"  :preview-src-list="onlyImgList"></el-image>
</div>
</template>
<script>
export default {
    name:'TabAlbum',
    props:{
        post:{
            type: Object,
            default:()=>{}
        }
    },
    data(){
        return {
            postLoading:false,
            atlasParams:{
                postId:'',
                offset:1,
                size:20,
                order:0,
                tagIdList:[],
            },
            tagsList:[],
            atlasList:[],
            atlasCount:1,
            controlData:{},
            showPrevPop:false,
            onlyImgList:[],

        }
    },
    created(){
        this.atlasParams.postId = this.post.id;
        this.getTags();
        this.getAtlas();
    },
    methods:{
        async getTags(){
            let result = await this.$axios.post('/comment/merchant/v1/get/album/tag/list',{});
            if( result.code == 0 ){
                
                this.tagsList = result.data.items;
                
            }
        },
        async getAtlas(){
            this.postLoading = true;
            let result = await this.$axios.post('/comment/merchant/v1/get/album/of/post',this.atlasParams)
            this.postLoading = false;
            if( result.code == 0 ){
                
                this.atlasList = result.data.items;
                this.atlasCount = result.data.total;
                let imgList = [];
                for(var i=0; i< this.atlasList.length;i++){
                    imgList.push( this.atlasList[i].url)
                }
                this.onlyImgList = imgList;
            }
        },
        pageChange(index){
            this.atlasParams.offset = index;
            this.getAtlas();
        },
        filterChange(id){
            if( id == 0 ){
                this.atlasParams.tagIdList = [];
            }else{
                this.atlasParams.tagIdList = [id];
            }
            this.atlasParams.offset = 1;
            this.getAtlas();
        },
        orderChange(orderIndex){
            if( this.atlasParams.order == orderIndex) return false;
            this.atlasParams.order = orderIndex;
            this.atlasParams.offset =1;
            this.getAtlas();
        },
        showPrev(atlas){
            this.controlData = atlas;
            this.showPrevPop = true;
            this.$refs['elImgPrev'].clickHandler();
        }

    }
}
</script>
<style lang="scss" scoped>
.album{
    .filter{
        display: flex;  padding-top: 20px; margin-bottom: 20px;
        .item{
            font-size: 14px; line-height: 30px; padding: 0 20px; border-radius: 15px; background: #f1f1f1; color: #222; margin: 0 20px 0 0 ;
            user-select: none; cursor: pointer;
            &.active{background: #ffe8e8; color: #ff0000;}
        }

        .sort{
            display: flex; flex:1; justify-content: right; align-items: center;
            .lit{
                font-size: 14px; line-height: 20px; color: #999; user-select: none; cursor: pointer;
                &:last-child{
                    margin-left: 10px; padding-left: 10px; border-left: 1px solid #BEBEBE;
                }
                &.active{color: #111;}
            }
        }
        
    }
    .atlas-list{
        margin: 0 -15px; display: flex; flex-wrap: wrap;
        li{
            width:20%; padding: 0 15px; margin-bottom: 20px; box-sizing: border-box;
            .box{
                position: relative; aspect-ratio: 21/16; border-radius: 4px; overflow: hidden;
                img{
                    display: block; width: 100%; height: 100%; object-fit: cover;
                }
                .dish-box{
                    position: absolute; left: 0; bottom: 0; right: 0; 
                    display: flex; background: rgba(0,0,0,0.5); color: #fff; font-size: 14px; line-height: 40px; padding: 0 10px;
                    .dish-name{flex:1;}
                }
            }
        }
    }
}
.no-data{
    padding: 20px 0; text-align: center;
    img{display: block; margin:0 auto;}
    .note{font-size: 14px; color: #ccc; margin-top: 15px;}
}
</style>